module.exports = __webpack_public_path__ + "img/cp-abundance-1.80bb4646.svg";